import React from 'react';

export default function AdvertiserDisclosure() {
  return (
    <div style={{ fontFamily: 'Lato', padding: '2rem' }}>
      <section>
        <h2>Advertiser Disclosure</h2>
        <p><strong>Transparency is important to us.</strong> Cardacademy is a free, independent blogging platform focused on helping users make better credit card decisions. To support our work, we may partner with banks, credit card issuers, or affiliate networks.</p>

        <h3>How We Make Money</h3>
        <p>Some of the links on our website are affiliate links. This means that if you click on a credit card link and apply or are approved, we may receive a commission at no extra cost to you.</p>

        <h3>Our Editorial Integrity</h3>
        <ul>
          <li>Our reviews, comparisons, and recommendations are always based on objective analysis and user value—<strong>not</strong> on compensation.</li>
          <li>We do not accept money in exchange for positive reviews.</li>
          <li>Affiliate partnerships do <strong>not</strong> influence the order of cards in our articles or comparison tables.</li>
        </ul>

        <h3>Why It Matters</h3>
        <p>Affiliate earnings help us maintain the website, create better tools, and write honest, well-researched content—so you can make informed decisions without paying a rupee extra.</p>

        <h3>We're On Your Side</h3>
        <p>We believe in building a community that understands how to use credit responsibly and smartly. Our priority is helping users like you get the most out of your financial tools—transparently and ethically.</p>

        <p>If you have any questions about our affiliate partnerships or how we work, please contact us at <strong>joincardacademy@gmail.com</strong>.</p>
      </section>
    </div>
  );
}
